import React from 'react';
import { compose } from 'redux';
import cloneDeep from 'lodash/cloneDeep';
import orderBy from 'lodash/orderBy';

import * as Table from 'reactabular-table';
import * as search from 'searchtabular';
import * as sort from 'sortabular';
import * as resolve from 'table-resolver';


import {
  Paginator, PrimaryControls, paginate
} from '../tableHelpers';


import _ from 'underscore';


import TreeView from 'react-treeview';

require('react-treeview/react-treeview.css');

import { Col, OverlayTrigger, Tooltip, Button } from 'react-bootstrap';


import { translate } from 'react-i18next';

@translate(['common'])
export default class SyncProductsTable extends React.Component {
  constructor(props) {
    super(props);



    this.state = {
      rows: this.props.fiches, // initial rows
      searchColumn: 'all',
      query: {}, // search query
      sortingColumns: null, // reference to the sorting columns
      columns: this.getColumns(), // initial columns
      pagination: { // initial pagination settings
        page: 1,
        perPage: 5
      }
    };

    this.onRow = this.onRow.bind(this);
    this.onRowSelected = this.onRowSelected.bind(this);
    this.onColumnChange = this.onColumnChange.bind(this);
    this.onSearch = this.onSearch.bind(this);
    this.onSelect = this.onSelect.bind(this);
    this.onPerPage = this.onPerPage.bind(this);
    this.onToggleColumn = this.onToggleColumn.bind(this);
    this.getColumns = this.getColumns.bind(this);
  }


  componentDidUpdate(prevProps) {
    if (prevProps.fiches !== this.props.fiches) {
      this.setState({ rows: this.props.fiches, columns: this.getColumns() })
    }
  }


  getColumns() {

    const {t} = this.props

    var self = this;

    const sortable = sort.sort({
      getSortingColumns: () => this.state.sortingColumns || [],
      onSort: selectedColumn => {
        this.setState({
          sortingColumns: sort.byColumns({ // sort.byColumn would work too
            sortingColumns: this.state.sortingColumns,
            selectedColumn
          })
        });
      }
    });

    const sortableHeader = sortHeader(sortable, () => this.state.sortingColumns);

    return [
      {
        header: {
          label: t("main.sheets"),
          formatters: [sortableHeader],
          props: {
            className: 'col-md-7'
          }
        },

        cell: {
          formatters: [(value, { rowData }) => {

            var prods = [];

            _.each(rowData.products, (p) => {
              prods.push(
                <TreeView key={p.identification_NUM_ASC} nodeLabel={p.identification_NUM_ASC} defaultCollapsed={true}>
                  <div>{p.localisation_adresse}</div>
                  <div>{p.localisation_ville}</div>
                  <div>{ t("main.pit")} : {p.identification_fosse}</div>
                </TreeView>
              );
            });
            return (
              <div>
                {prods}
              </div>
            )
          }]

        },
        width: 20,
        visible: true
      },

      {
        property: 'gsm',
        header: {
          label: 'GSM',
          formatters: [sortableHeader],
          props: {
            className: 'col-md-1'
          }
        },
        visible: true
      },

      {


        cell: {
          formatters: [(value, { rowData }) => {

            var tooltip = (
              <Tooltip id="tooltip">
                <b>
                  { t("GSMList.tooltip1"), {group_name:this.props.group ? this.props.group.name : ''}}                                                  
                </b></Tooltip>
            );

            return <OverlayTrigger placement="top" overlay={tooltip}><Button bsStyle="primary" disabled={self.props.loading} className="btn btn-default" type="button" onClick={() => {
              if (!self.props.loading) {
                self.props.associateGSM(rowData);
              }
            }}>
              { t("GSMList.associate")}
					  </Button>
            </OverlayTrigger>

          }]

        },
        width: 20,
        visible: true
      },





    ];
  }
  render() {

    const {t} = this.props
    const {
      rows, pagination, sortingColumns, searchColumn, query
    } = this.state;

    var columns = this.getColumns()

    const cols = columns.filter(column => column.visible);
    const paginated = compose(
      paginate(pagination),
      sort.sorter({ columns: cols, sortingColumns, sort: orderBy }),
      search.highlighter({ columns: cols, matches: search.matches, query }),
      search.multipleColumns({ columns: cols, query }),
      resolve.resolve({
        columns: cols,
        method: ({ rowData, column }) => resolve.byFunction('cell.resolve')({
          rowData: resolve.nested({ rowData, column }),
          column
        })
      })
    )(rows);




    var loading_text = this.props.loading ? <i className="fa fa-cog fa-spin fa-2x fa-fw"></i> : "";

    return (
      <Col xs={12}>

        <div style={{
          position: '',
          border: '1px solid lightgrey',
          padding: '12px 12px 30px 12px',
          background: ''
        }}
        >

          {/*<VisibilityToggles
          columns={columns}
          onToggleColumn={this.onToggleColumn}
        />*/}



          {rows.length > 0 &&
            <div>
              <div>
                <h4 style={{ 'display': 'inline' }}>                
                  { t("GSMList.associate_sheets") }                                    
                  </h4>{loading_text}<br /><br />
                <PrimaryControls
                  className="controls"
                  perPage={pagination.perPage}
                  column={searchColumn}
                  query={query}
                  columns={cols}
                  rows={rows}
                  onPerPage={this.onPerPage}
                  onColumnChange={this.onColumnChange}
                  onSearch={this.onSearch}
                  t={t}
                />

                <Table.Provider
                  className="table table-striped"
                  columns={cols}
                  style={{ overflowX: 'auto' }}
                >
                  <Table.Header>
                    {/*<SearchColumns query={query} columns={cols} onChange={this.onSearch} />*/}
                  </Table.Header>

                  <Table.Body onRow={this.onRow} rows={paginated.rows} rowKey="id" />

                  {/*<CustomFooter columns={cols} rows={paginated.rows} />*/}
                </Table.Provider>



              </div>

              <div className="controls">
                <Paginator
                  pagination={pagination}
                  pages={paginated.amount}
                  onSelect={this.onSelect}
                  prevText={t("pagination.previous")}
                  nextText={t("pagination.next")}
                />
              </div>
            </div>

          }

          {rows.length == 0 &&
            <span><b>              
              { t("GSMList.all_sheets_associated") }                            
              </b></span>
          }



        </div>

      </Col>
    );
  }
  onRow(row, { rowIndex }) {
    return {
      onClick: () => this.onRowSelected(row)
    };
  }
  onRowSelected(row) {

  }
  onColumnChange(searchColumn) {
    this.setState({
      searchColumn
    });
  }
  onSearch(query) {
    this.setState({
      query
    });
  }
  onSelect(page) {
    const pages = Math.ceil(
      this.state.rows.length / this.state.pagination.perPage
    );

    this.setState({
      pagination: {
        ...this.state.pagination,
        page: Math.min(Math.max(page, 1), pages)
      }
    });
  }
  onPerPage(value) {
    this.setState({
      pagination: {
        ...this.state.pagination,
        perPage: parseInt(value, 10)
      }
    });
  }

  onToggleColumn(columnIndex) {
    const columns = cloneDeep(this.state.columns);
    const column = columns[columnIndex];
    column.visible = !column.visible;
    const query = cloneDeep(this.state.query);
    delete query[column.property];
    this.setState({ columns, query });
  }
}

const CustomFooter = ({ columns, rows }) => {
  return (
    <tfoot>
      <tr>
        {columns.map((column, i) =>
          <td key={`footer-${i}`}>{column.footer ? column.footer(rows) : null}</td>
        )}
      </tr>
    </tfoot>
  );
}

function sortHeader(sortable, getSortingColumns) {
  return (value, { columnIndex }) => {
    const sortingColumns = getSortingColumns() || [];

    return (
      <div style={{ display: 'inline' }}>
        <span className="value">{value}</span>
        {React.createElement(
          'span',
          sortable(
            value,
            {
              columnIndex
            },
            {
              style: { float: 'right' }
            }
          )
        )}
        {sortingColumns[columnIndex] &&
          <span className="sort-order" style={{ marginLeft: '0.5em', float: 'right' }}>
            {sortingColumns[columnIndex].position + 1}
          </span>
        }
      </div>
    );
  };
}